import {
  FormContainerValues,
  FormContainerAction,
  SET_CUSTOMER,
  SET_BRANCH_DETAILS,
  SET_ERROR,
  RESET_ERROR,
} from './types';

export const reducer = (
  state: FormContainerValues,
  action: FormContainerAction
) => {
  switch (action.type) {
    case SET_CUSTOMER:
      return {
        ...state,
        customer: action.value.customer,
      };
    case SET_BRANCH_DETAILS:
      return {
        ...state,
        bankBranch: action.value.bankBranch,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.value.error,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: action.value.error,
      };
    default:
      return state;
  }
};
